import { useEffect } from 'react';
import { sendViewItemEvent } from '@/features/analytics/datalayer';
import { ViewItemType } from '@/features/analytics/datalayer/types';
import { getProductURL } from '@/features/navigation/utils/url-helpers';
import { AppNextLink } from '@/features/app-next-link';
import { Button } from '@/features/button';
import { IconClose, IconGift } from '@/features/icons';
import { AppButtonPricing } from '@/features/product-card/app-button';
import { Webengage } from '@/features/webengage';
import VariantsContainer from '@/app/(pdp)/_components/variants/variants-container';
import usePDPData from '@/app/(pdp)/_utils/use-pdp-data';
import { useVariantContextValues } from '@/app/(pdp)/context/use-variant-context-values';
import BuyButton from './buy-button';
import Gallery from './gallery';
import Skeleton from './skeleton';
interface Props {
  productSlug: string;
  closeHandler: () => void;
}
const Content = ({
  productSlug,
  closeHandler
}: Props) => {
  const {
    data,
    isLoading
  } = usePDPData(productSlug);
  const {
    activePricing,
    activeVariant
  } = useVariantContextValues('baby-pdp');
  const {
    basePrice,
    discountPercent,
    effectivePrice,
    isSalable
  } = activePricing;
  useEffect(() => {
    if (!data) return;
    sendViewItemEvent(data, ViewItemType.Video);
    Webengage.trackViewPdp(data, ViewItemType.Video);
  }, [data]);
  const pdpPageUrl = getProductURL(data?.slug || '');
  const giftName = activeVariant?.giftVariantNameFa;
  return <div className='flex flex-col gap-4 pt-2' data-sentry-component="Content" data-sentry-source-file="content.tsx">
            <button onClick={closeHandler} className='mx-3 w-fit self-end'>
                <IconClose className='h-6 w-6 text-text-mediumGray' data-sentry-element="IconClose" data-sentry-source-file="content.tsx" />
            </button>

            {isLoading ? <Skeleton /> : <>
                    <div className='px-5'>
                        <Gallery slug={productSlug} />
                    </div>

                    <span className='px-3 text-body-16 font-medium text-black'>{data?.nameFa}</span>

                    <VariantsContainer className='gap-3 px-3 lg:gap-3' isCarousel contextType='baby-pdp' />

                    <AppNextLink href={pdpPageUrl} className='border-y border-solid border-border-gray-light bg-surface-solid-50'>
                        <Button graphicStyle='text' size='large' className='mx-auto font-normal text-black hover:text-black'>
                            اطلاعات کامل محصول
                        </Button>
                    </AppNextLink>

                    {!!giftName && <div className='mx-3 flex items-center gap-1.5 bg-primary-shade-100 px-4 py-1.5 text-primary-main'>
                            <div className='h-5 w-5'>
                                <IconGift className='h-5 w-5' />
                            </div>
                            <span className='text-caption-12 lg:text-body-14'>
                                با خرید این محصول، یک <span className='font-bold'>{giftName}</span> هدیه می‌گیرید!
                            </span>
                        </div>}

                    {isSalable ? <div className='flex min-h-[68px] items-center px-3 pb-4 lg:min-h-[70px]'>
                            <BuyButton />

                            <div className='mr-auto flex min-w-[125px] justify-center'>
                                <AppButtonPricing basePrice={basePrice} discountPercent={discountPercent} effectivePrice={effectivePrice} contextType='baby-pdp' />
                            </div>
                        </div> : <span className='mx-auto flex min-h-[68px] items-center justify-center text-caption-12 text-text-darkGray lg:min-h-[70px]'>
                            این محصول ناموجود است.
                        </span>}
                </>}
        </div>;
};
export default Content;